import { getUserGeoInfo } from 'dibs-regional-info/exports/regionalInfoHelpers';
import { FC, ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import { PdpSharedShippingInfo } from './PdpSharedShippingInfo';

import { PdpSharedShippingInfoWrapper_item$key } from './__generated__/PdpSharedShippingInfoWrapper_item.graphql';
import { PdpSharedShippingInfoWrapper_user$key } from './__generated__/PdpSharedShippingInfoWrapper_user.graphql';

type Props = {
    item: PdpSharedShippingInfoWrapper_item$key;
    user: PdpSharedShippingInfoWrapper_user$key | null;
    currency: string;
    children?: ReactNode;
    leadTime?: string | null;
    renderTooltip?: boolean;
    isClient?: boolean;
    title?: ReactNode;
    displayInline?: boolean;
    preLinkQuoteDetails?: ReactNode;
    postLinkQuoteDetails?: ReactNode;
    postLinkNoQuoteDetails?: ReactNode;
    itemQuantity?: number | null;
    calculateLowerShippingInfo?: boolean;
};

const PdpSharedShippingInfoWrapper: FC<Props> = ({
    item: itemRef,
    user: userRef,
    currency,
    children,
    leadTime,
    renderTooltip,
    isClient = false,
    title,
    displayInline,
    preLinkQuoteDetails,
    postLinkQuoteDetails,
    postLinkNoQuoteDetails,
    itemQuantity,
    calculateLowerShippingInfo = false,
}) => {
    const user = useFragment(
        graphql`
            fragment PdpSharedShippingInfoWrapper_user on User {
                serviceId
                isVerifiedTrade
            }
        `,
        userRef
    );
    const item = useFragment(
        graphql`
            fragment PdpSharedShippingInfoWrapper_item on Item {
                serviceId
            }
        `,
        itemRef
    );

    const userGeoInfo = getUserGeoInfo();

    return (
        <PdpSharedShippingInfo
            renderTooltip={renderTooltip}
            currency={currency}
            leadTime={leadTime || ''}
            itemId={item.serviceId || ''}
            userId={user?.serviceId || ''}
            isTrade={user?.isVerifiedTrade || false}
            title={title}
            displayInline={displayInline}
            preLinkQuoteDetails={preLinkQuoteDetails}
            postLinkQuoteDetails={postLinkQuoteDetails}
            postLinkNoQuoteDetails={postLinkNoQuoteDetails}
            isClient={isClient}
            itemQuantity={itemQuantity}
            userZipCode={userGeoInfo?.zipCode}
            userCountryCode={userGeoInfo?.countryCode}
            calculateLowerShippingInfo={calculateLowerShippingInfo}
        >
            {children}
        </PdpSharedShippingInfo>
    );
};

export default PdpSharedShippingInfoWrapper;
